<template>
  <div
    class="upsellModalContainer"
    :style="{
      backgroundColor: secondNestedModalIsVisible ? 'transparent' : 'rgba(0, 0, 0, 0.5)',
    }"
  >
    <SecondLayerNestedModifierModal
      v-if="secondNestedModalIsVisible"
      @goBack="goBackToFirstLayer"
      @doneButtonClicked="getSubChoices"
      :upsellData="selectedUpsellData"
      :itemQuantity="itemQuantity"
      :mode="nestedModalMode"
      :choiceChildItems="secondChoiceChildItems"
    />
    <div :style="{ display: secondNestedModalIsVisible ? 'none' : 'flex' }" class="modalWrapper">
      <div class="infoWrapper">
        <a @click="goBack('back')" class="back" href="javascript:;">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 241.521 415.783">
            <path
              id="Path_19208"
              data-name="Path 19208"
              d="M460.94,81.871a33.6,33.6,0,0,0-47.546,0l-174.33,174.39a33.6,33.6,0,0,0,0,47.484l174.39,174.39A33.6,
                33.6,0,0,0,461,430.647L310.3,280.007l150.64-150.64a33.605,33.605,0,0,0,0-47.488Z"
              transform="translate(-229.24 -72.016)"
            />
          </svg>
          <p>GO BACK</p>
        </a>
        <h3 class="nameUpsell">
          {{ upsellData.name }}
        </h3>
        <h3 v-if="upsellData.baseprice != 0" class="priceUpsell">
          {{ formatPrice(upsellData.baseprice) }}
        </h3>
        <p v-if="upsellData.description != ''">
          {{ upsellData.description }}
        </p>
      </div>
      <div class="modifiers">
        <div v-for="modifier in upsellData.child_pick_list_data.pick_lists" :key="modifier" class="modifier">
          <div v-show="modifier.display_style != 'hidden'">
            <div
              class="modifierHeader"
              @click="expandModifier(modifier.pick_list_id)"
              :style="branding?.display_options?.collapsable_modifiers ? 'cursor: pointer' : ''"
            >
              <div class="modifierInfo">
                <h3 class="modifierName">
                  {{ modifier.prompt }}
                </h3>
                <div class="modifierTypeWrapper">
                  <p class="modifierType">
                    {{ modifier.mincount == 0 ? 'OPTIONAL' : 'REQUIRED' }}
                  </p>
                  <p v-if="getMinMax(modifier) != ''" class="modifierSelect">
                    {{ getMinMax(modifier) }}
                  </p>
                </div>
              </div>
              <svg
                v-if="branding?.display_options?.collapsable_modifiers"
                src="@/assets/icons/downArrow.svg"
                class="expandCollapse"
                :class="{ rotate: checkIfModifierVisible(modifier.pick_list_id) }"
                width="12"
                height="9"
                viewBox="0 0 12 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.53558 7.93101L0.221517 2.61692C-0.0347764 2.36063 -0.0347764 1.94511 0.221517 1.68885L0.841317 1.06904C1.09717 0.813189 1.51184 0.812697 1.7683 1.06795L5.99963 5.27946L10.2309 1.06795C10.4874 0.812697 10.9021 0.813189 11.1579 1.06904L11.7777 1.68885C12.034 1.94514 12.034 2.36065 11.7777 2.61692L6.46368 7.93101C6.20739 8.18728 5.79188 8.18728 5.53558 7.93101Z"
                  fill="#171717"
                />
              </svg>
            </div>
            <div
              v-show="checkIfModifierVisible(modifier.pick_list_id)"
              :class="{ gridChoices: branding?.display_options?.modifier_display_style == 'grid' }"
            >
              <ChoiceCell
                v-for="choice in modifier.pick_list_items"
                :key="choice"
                :choice="choice"
                :modifier="modifier"
                @openUpsellModal="openUpsellModal"
                @selectSide="selectSide"
                @changeChoiceQty="changeChoiceQty"
                :checkIfFallbackImage="checkIfFallbackImage"
                :selected="checkIfSelected(modifier, choice)"
                :selectedCount="getSelectedCount(choice.itemid)"
                :selectedChildItemNames="getSelectedChildItemNames(choice.itemid)"
                :leftSelected="checkIfSideSelected(choice, 'Left')"
                :rightSelected="checkIfSideSelected(choice, 'Right')"
                :wholeSelected="checkIfSideSelected(choice, 'Whole')"
                :pizzaSidePrice="getPizzaSidePrice(choice)"
                :multiChoiceQuantity="getMultiChoiceQuantity(choice)"
                :hasRequiredNestedModifiers="checkIfHasRequiredNestedModifiers(modifier, choice)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="doneButton"
        :style="{ backgroundColor: branding.dark_mode_enabled ? 'var(--background-color)' : '#FFFFFF' }"
      >
        <button @click="doneButtonClicked">DONE</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import choiceMixins from '@/mixins/choiceMixins.js'
import formattingMixins from '@/mixins/formattingMixins'

import ChoiceCell from '@/components/Modals/ItemModals/ChoiceCell.vue'
import SecondLayerNestedModifierModal from '@/components/Modals/ItemModals/SecondLayerNestedModifierModal.vue'

export default {
  data() {
    return {
      openNutritionChoicesIds: [],
      secondNestedModalIsVisible: false,
      nestedModalMode: 'add',
      secondChoiceChildItems: null,
      expandedModifiers: [],
    }
  },
  mixins: [choiceMixins, formattingMixins],
  props: ['upsellData', 'itemQuantity', 'choiceChildItems', 'mode', 'parentChoiceQty'],
  components: {
    ChoiceCell,
    SecondLayerNestedModifierModal,
  },
  computed: {
    ...mapState(['storeConfig', 'branding']),
  },
  methods: {
    ...mapMutations(['SET_TOASTER']),
    goBack(type) {
      this.$emit('goBack', type, this.upsellData.itemid)
    },
    expandModifier(pickListId) {
      if (!this.branding?.display_options?.collapsable_modifiers) return
      let modifier = this.expandedModifiers.find((modifier) => modifier.pick_list_id === pickListId)
      if (modifier) {
        this.expandedModifiers = this.expandedModifiers.filter((modifier) => modifier.pick_list_id !== pickListId)
        return
      }
      this.expandedModifiers.push({ pick_list_id: pickListId })
    },
    checkIfModifierVisible(pickListId) {
      if (!this.branding?.display_options?.collapsable_modifiers) return true
      // check if modifier is in expandedModifiers
      let modifier = this.expandedModifiers.find((modifier) => modifier.pick_list_id === pickListId)
      if (modifier) return true
      return false
    },
    goBackToFirstLayer(type, itemId) {
      if (type == 'back' && this.nestedModalMode != 'edit') {
        let choice = this.selectedChildItems.find((item) => item.item_id === itemId)
        this.choicesPrice -= choice.price
        this.selectedChildItems = this.selectedChildItems.filter((item) => item.item_id !== itemId)
      }
      this.secondNestedModalIsVisible = false
    },
    openUpsellModal(modifier, choice, mode) {
      if (mode == 'edit') {
        this.nestedModalMode = 'edit'
        let childItems = this.selectedChildItems.filter((item) => item.item_id === choice.itemid)
        this.secondChoiceChildItems = childItems[0].child_items || []
        this.selectedUpsellData = choice
        this.toggleUpsellModal()
        return
      }
      this.nestedModalMode = 'add'
      if (!choice.child_pick_list_data) {
        this.selectChoice(modifier, choice, this.parentChoiceQty)
        return
      }
      this.selectChoice(modifier, choice)
      // if upsell is already selected don't open modal
      if (!this.selectedChildItems.find((item) => item.item_id === choice.itemid)) {
        return
      }
      this.selectedUpsellData = choice
      this.toggleUpsellModal()
    },
    getSubChoices(childItems, choicePrice, choiceId) {
      let mainChoice = this.selectedChildItems.find((item) => item.item_id === choiceId)
      mainChoice.child_items = childItems
      this.secondNestedModalIsVisible = false
      this.calculateChoicesPrice()
    },
    checkIfFallbackImage(url) {
      return url.includes('fallback')
    },
    doneButtonClicked() {
      if (this.checkRequiredSelections(this.upsellData.child_pick_list_data.pick_lists) == false) {
        return
      }
      for (let item in this.selectedChildItems) {
        // find the item in the modifiers
        let modifier = this.upsellData.child_pick_list_data.pick_lists.find(
          (modifier) => modifier.pick_list_id == this.selectedChildItems[item].pick_list_id
        )
        if (modifier) {
          // find the choice in modifier
          let choice = modifier.pick_list_items.find((choice) => choice.itemid == this.selectedChildItems[item].item_id)
          if (this.checkIfHasRequiredNestedModifiers(modifier, choice)) {
            let toasterData = {
              show: true,
              message: 'Please select required selections for ' + "'" + choice.name + "'",
            }
            this.SET_TOASTER(toasterData)
            return
          }
        }
      }
      this.$emit('doneButtonClicked', this.selectedChildItems, this.choicesPrice, this.upsellData.itemid)
      this.goBack('apply')
    },
    toggleUpsellModal() {
      this.secondNestedModalIsVisible = !this.secondNestedModalIsVisible
    },
  },
  created() {
    if (this.mode == 'edit') {
      this.selectedChildItems = this.choiceChildItems
    } else {
      this.getPreSelectedChoices(this.upsellData.child_pick_list_data.pick_lists)
    }
  },
}
</script>

<style src="../../../assets/css/Modals/ItemModals/NestedModifierModal.css" scoped></style>
